import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cbad73a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h4 title fw-normal text-primary mb-16" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "middle-container mb-16" }
const _hoisted_4 = { class: "middle-content" }
const _hoisted_5 = { class: "row row-cols-3 mb-16" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "section-title fw-bold" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "section-title fw-bold" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "section-title fw-bold" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "row row-cols-3 mb-24" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "section-title fw-bold" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "section-title fw-bold" }
const _hoisted_21 = { class: "content" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "section-title fw-bold" }
const _hoisted_24 = { class: "content" }
const _hoisted_25 = { class: "observations mb-12" }
const _hoisted_26 = { class: "section-title fw-bold" }
const _hoisted_27 = { class: "content" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col" }
const _hoisted_30 = { class: "section-title fw-bold d-flex justify-content-between align-items-center mb-12" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_32 = { class: "authorizations" }
const _hoisted_33 = { class: "d-inline product" }
const _hoisted_34 = { class: "d-inline product" }
const _hoisted_35 = { class: "d-inline product" }
const _hoisted_36 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-view-light fw-bold icon-xs" }, null, -1))
const _hoisted_38 = {
  key: 1,
  class: "item d-flex align-items-center justify-content-between"
}
const _hoisted_39 = { class: "add" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-add text-xs fw-bold" }, null, -1))
const _hoisted_41 = { class: "bottom-section d-flex align-items-center justify-content-end" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-edit-light me-12",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_purchase_authorization_create = _resolveComponent("the-purchase-authorization-create")!
  const _component_the_purchase_authorization_show = _resolveComponent("the-purchase-authorization-show")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$t('Visualización de')) + " ", 1),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('consulta')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('Inicio')), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$str.formatDateTime(_ctx.currentConsultation.initDate)), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('Fin')), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(!!_ctx.currentConsultation.endDate ? _ctx.$str.formatDateTime(_ctx.currentConsultation.endDate) : '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('Tipo de consulta')), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.type()), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('Medio')), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.via()), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('Lugar')), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(!!_ctx.currentConsultation.clinic ? _ctx.currentConsultation.clinic.name : _ctx.$t('- Sin clínica asociada -')), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('Tratamiento')), 1),
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.currentConsultation.treatment && _ctx.currentConsultation.treatment.treatmentProtocolPhases ? '[' +
                _ctx.$str.formatDate(_ctx.currentConsultation.treatment.treatmentProtocolPhases[0].initDate) + '] ' +
                _ctx.currentConsultation.treatment.treatmentProtocolPhases[0].protocolPhase.protocol.name +
                ' (' + _ctx.currentConsultation.treatment.treatmentProtocolPhases[0].protocolPhase.name + ')' :
                _ctx.$t('- Sin tratamiento asociado -')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('Observaciones')), 1),
          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.currentConsultation.observations), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createTextVNode(_toDisplayString(_ctx.$t('Autorizaciones relacionadas')) + " ", 1),
              (_ctx.can('professional.expedient.purchase-authorization.store'))
                ? (_openBlock(), _createBlock(_component_v_button, {
                    key: 0,
                    variant: "secondary",
                    size: "xs",
                    class: "new-consultation",
                    "aria-label": _ctx.$t('Crear autorización de compra'),
                    onClick: _ctx.showPurchaseAuthorizationCreateModal
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Nueva')), 1)
                    ]),
                    _: 1
                  }, 8, ["aria-label", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_32, [
              (_ctx.consultationAuthorizations().length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.consultationAuthorizations(), (purchaseAuthorization, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item d-flex align-items-center justify-content-between",
                      key: index
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$str.formatDate(purchaseAuthorization.dueDate)), 1),
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('Estado')) + ": " + _toDisplayString(_ctx.status(purchaseAuthorization.status)), 1),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('{count} productos distintos', { count: purchaseAuthorization.products.length })), 1)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_v_button, {
                          variant: "icon",
                          class: "p-0 me-16",
                          onClick: ($event: any) => {_ctx.setCurrentPurchase(purchaseAuthorization); _ctx.modalToShow = 'the-purchase-authorization-show'}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_37
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.$t('No hay autorizaciones relacionadas con esta consulta')), 1)),
              _createElementVNode("div", _hoisted_39, [
                (_ctx.can('professional.expedient.purchase-authorization.store'))
                  ? (_openBlock(), _createBlock(_component_v_button, {
                      key: 0,
                      variant: "icon",
                      class: "w-100 justify-content-center",
                      "aria-label": this.$t('Nueva autorización'),
                      onClick: _ctx.showPurchaseAuthorizationCreateModal
                    }, {
                      default: _withCtx(() => [
                        _hoisted_40
                      ]),
                      _: 1
                    }, 8, ["aria-label", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      (_ctx.can('professional.expedient.consultation.update'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: {name: 'professional.expedient.consultation.update',
    params: {
      tabName: 'consultas',
      consultation: _ctx.currentConsultation.id,
    },
    query: {
      tratamiento: _ctx.currentTreatment?.id,
      }},
            class: "btn btn-icon btn-outline-secondary btn-sm edit-consultation me-24",
            "aria-label": _ctx.$t('Editar consulta')
          }, {
            default: _withCtx(() => [
              _hoisted_42,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Editar')), 1)
            ]),
            _: 1
          }, 8, ["to", "aria-label"]))
        : _createCommentVNode("", true),
      (_ctx.can('professional.expedient.consultation.store'))
        ? (_openBlock(), _createBlock(_component_v_button, {
            key: 1,
            variant: "secondary",
            "aria-label": _ctx.$t('Nueva consulta'),
            onClick: _ctx.emitCreateConsultation
          }, {
            default: _withCtx(() => [
              _hoisted_43,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Nueva consulta')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.modalToShow === 'the-purchase-authorization-create')
      ? (_openBlock(), _createBlock(_component_the_purchase_authorization_create, {
          key: 0,
          "consultation-id": _ctx.currentConsultation.id,
          onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalToShow = null)),
          onPurchaseAuthorizationCreated: _cache[1] || (_cache[1] = ($event: any) => {_ctx.loadPurchaseAuthorizations(); _ctx.modalToShow = null})
        }, null, 8, ["consultation-id"]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-purchase-authorization-show')
      ? (_openBlock(), _createBlock(_component_the_purchase_authorization_show, {
          key: 1,
          onClosed: _cache[2] || (_cache[2] = ($event: any) => {_ctx.modalToShow = null; _ctx.setCurrentPurchase()})
        }))
      : _createCommentVNode("", true)
  ], 64))
}